import React, { PureComponent } from "react";
import { connect } from "react-redux";
import {
  initTaskTypeList,
  setCurrentNavPage,
  setSubMenuDirection,
  setSubMenuDirectionToggle
} from "Actions";
import {
  fetchTaskTypeList,
  fetchTaskCategoryList,
  fetchValuationSuggestions,
  fetchNonCategorizedTaskTypeCount
} from "Thunks";
import { HORIZONTAL, VERTICAL } from "Config";
import TaskTypeList from "./TaskTypeList";

class TaskTypeSettingsPage extends PureComponent {
  constructor(props) {
    super(props);
    let { uen } = this.props.match.params;

    this.state = { organizationUen: uen };
  }

  componentDidMount() {
    const { dispatch, subMenuDirection } = this.props;

    dispatch(setCurrentNavPage("TASK_TYPE_SETTING"));

    if (subMenuDirection === VERTICAL) {
      dispatch(setSubMenuDirection(HORIZONTAL));
    }
    dispatch(setSubMenuDirectionToggle(true));

    let { uen } = this.props.match.params;
    this.setState({ organizationUen: uen });

    dispatch(initTaskTypeList());
    dispatch(fetchTaskTypeList(true, true));
    dispatch(fetchTaskCategoryList());
    dispatch(fetchValuationSuggestions());
    dispatch(fetchNonCategorizedTaskTypeCount());
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(setSubMenuDirectionToggle(true));
  }

  render() {
    return (
      <div className={`page-content`}>
        <TaskTypeList uen={this.state.organizationUen} />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  subMenuDirection: state.params.subMenuDirection,
  currentOrganization: state.auth.currentOrganization
});

// export default TaskTypeSettingsPage;
export default connect(mapStateToProps)(TaskTypeSettingsPage);



// WEBPACK FOOTER //
// ./src/components/TaskType/TaskTypeSettingsPage.js